import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';
const communities = [{
  name: 'Summerlin',
  path: '/summerlin',
  description: 'Master-planned luxury community with world-class amenities, golf courses, and Red Rock Canyon views.',
  image: 'https://images.unsplash.com/photo-1512917774080-9991f1c4c750?q=80&w=2940&auto=format&fit=crop',
  alt: 'Luxury homes for sale in Summerlin Las Vegas with Red Rock Canyon views'
}, {
  name: 'Southern Highlands',
  path: '/southern-highlands',
  description: 'Exclusive gated community featuring championship golf and Mediterranean-inspired estates.',
  image: 'https://images.unsplash.com/photo-1600596542815-ffad4c1539a9?q=80&w=2950&auto=format&fit=crop',
  alt: 'Mediterranean luxury estate in Southern Highlands gated community Las Vegas'
}, {
  name: 'Henderson',
  path: '/henderson',
  description: "Nevada's second-largest city offering upscale living in Green Valley Ranch and Anthem.",
  image: 'https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?q=80&w=2906&auto=format&fit=crop',
  alt: 'Upscale homes for sale in Henderson Nevada near Green Valley and Anthem'
}, {
  name: 'MacDonald Highlands',
  path: '/macdonald-highlands',
  description: 'Ultra-luxury gated enclave in Henderson with panoramic city views and DragonRidge Country Club.',
  image: 'https://cdn.magicpatterns.com/uploads/4CGH46PAJnCeukNkRPai4M/MacDonald_Highlands.jpg',
  alt: 'MacDonald Highlands luxury estate and golf course with panoramic Las Vegas Strip views at dusk'
}, {
  name: 'Spring Valley',
  path: '/spring-valley',
  description: 'Centrally located with diverse luxury options, expansive lots, and easy Strip access.',
  image: 'https://cdn.magicpatterns.com/uploads/ixs3NMr1r7DpHyKfbe9dx5/spring_valley.jpg',
  alt: 'Luxury kitchen interior in Spring Valley Las Vegas home for sale'
}, {
  name: 'Southwest Las Vegas',
  path: '/southwest',
  description: 'Rapidly growing area with modern developments, custom homes, and mountain views.',
  image: 'https://images.unsplash.com/photo-1600585154526-990dced4db0d?q=80&w=2787&auto=format&fit=crop',
  alt: 'New construction homes in Southwest Las Vegas with mountain views'
}, {
  name: 'North Las Vegas',
  path: '/north-las-vegas',
  description: 'Emerging market with new master-planned communities and excellent investment opportunities.',
  image: 'https://images.unsplash.com/photo-1512915922686-57c11dde9b6b?q=80&w=2946&auto=format&fit=crop',
  alt: 'Affordable new homes in North Las Vegas master-planned communities'
}, {
  name: 'Green Valley',
  path: '/green-valley',
  description: 'Established upscale community known for beautiful parks, top schools, and refined family living.',
  image: 'https://images.unsplash.com/photo-1600047509807-ba8f99d2cdde?q=80&w=2792&auto=format&fit=crop',
  alt: 'Family homes in Green Valley Henderson with parks and top-rated schools'
}];
export function Communities() {
  return <section id="communities" className="py-24 bg-warmGray px-6" data-id="element-63">
      <div className="max-w-7xl mx-auto" data-id="element-64">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-65">
          <span className="text-gold uppercase tracking-[0.2em] text-sm font-medium mb-4 block" data-id="element-66">
            Explore Areas
          </span>
          <h2 className="text-4xl md:text-5xl font-serif text-charcoal" data-id="element-67">
            Featured Communities
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-12" data-id="element-68">
          {communities.map((community, index) => {
          const CardWrapper = community.path ? Link : 'div';
          return <motion.div key={community.name} initial={{
            opacity: 0,
            y: 30
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.6,
            delay: index * 0.1
          }} data-id="element-69">
                <CardWrapper to={community.path || '#'} className="group cursor-pointer block" data-id="element-70">
                  <div className="relative h-[400px] mb-6 overflow-hidden" data-id="element-71">
                    <div className="absolute inset-0 bg-charcoal/20 group-hover:bg-transparent transition-colors duration-500 z-10" data-id="element-72"></div>
                    <img src={community.image} alt={community.alt} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" data-id="element-73" />
                  </div>
                  <div className="pr-8" data-id="element-74">
                    <h3 className="text-2xl font-serif text-charcoal mb-3 group-hover:text-gold transition-colors duration-300" data-id="element-75">
                      {community.name}
                    </h3>
                    <p className="text-charcoal-light font-light mb-4 line-clamp-2" data-id="element-76">
                      {community.description}
                    </p>
                    <div className="flex items-center text-gold uppercase tracking-widest text-sm font-medium" data-id="element-77">
                      <span className="mr-2" data-id="element-78">Explore</span>
                      <ArrowRight className="w-4 h-4 transition-transform duration-300 group-hover:translate-x-2" data-id="element-79" />
                    </div>
                  </div>
                </CardWrapper>
              </motion.div>;
        })}
        </div>
      </div>
    </section>;
}